/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from '../initialState';
var addChangedQCFilter = produce(function (draft, action) {
  var stepKey = action.payload.stepKey;
  draft.processing.meta.changedQCFilters.add(stepKey);
}, initialState);
export default addChangedQCFilter;